import { ref as l, provide as o, createElementBlock as p, openBlock as u, renderSlot as v } from "vue";
import { themeProp as f } from "../../composables/useTheme.js";
const I = { class: "ds-accordion" }, k = /* @__PURE__ */ Object.assign({
  name: "DsAccordion"
}, {
  __name: "accordion",
  props: {
    ...f
  },
  emits: ["item-closed", "item-opened"],
  setup(i, { emit: m }) {
    const r = i, n = m, e = l(""), a = (t, c, s) => {
      if (t === "close") {
        e.value === s && (e.value = ""), n("item-closed", { label: c });
        return;
      }
      e.value = s, n("item-opened", { label: c });
    }, d = (t) => {
      e.value = t;
    };
    return o("activeItem", e), o("trackingData", { "component-name": "DsAccordion" }), o("setActiveItem", d), o("onItemClicked", a), o("theme", r.theme), (t, c) => (u(), p("div", I, [
      v(t.$slots, "default")
    ]));
  }
});
export {
  k as default
};
